/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { KrAddressResultVo } from './KrAddressResultVo';
import {
    KrAddressResultVoFromJSON,
    KrAddressResultVoFromJSONTyped,
    KrAddressResultVoToJSON,
    KrAddressResultVoToJSONTyped,
} from './KrAddressResultVo';

/**
 * 
 * @export
 * @interface ResponseKrAddressResultVo
 */
export interface ResponseKrAddressResultVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseKrAddressResultVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseKrAddressResultVo
     */
    message?: string;
    /**
     * 
     * @type {KrAddressResultVo}
     * @memberof ResponseKrAddressResultVo
     */
    data?: KrAddressResultVo;
}

/**
 * Check if a given object implements the ResponseKrAddressResultVo interface.
 */
export function instanceOfResponseKrAddressResultVo(value: object): value is ResponseKrAddressResultVo {
    return true;
}

export function ResponseKrAddressResultVoFromJSON(json: any): ResponseKrAddressResultVo {
    return ResponseKrAddressResultVoFromJSONTyped(json, false);
}

export function ResponseKrAddressResultVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseKrAddressResultVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : KrAddressResultVoFromJSON(json['data']),
    };
}

export function ResponseKrAddressResultVoToJSON(json: any): ResponseKrAddressResultVo {
    return ResponseKrAddressResultVoToJSONTyped(json, false);
}

export function ResponseKrAddressResultVoToJSONTyped(value?: ResponseKrAddressResultVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': KrAddressResultVoToJSON(value['data']),
    };
}

